import {
  OpenTofuMigrationFailedIssueNode,
  OpenTofuMigrationIssueNode,
  OpenTofuMigrationWaitingForRunsIssueNode,
} from "./gql";

export const getStackVendorSettingsUrl = (stackId: string) => `/stack/${stackId}/settings/vendor`;

export const getOpenTofuMigrationFailedIssue = (issues: OpenTofuMigrationIssueNode[]) =>
  issues.find(
    (issue): issue is OpenTofuMigrationFailedIssueNode =>
      issue.__typename === "OpenTofuMigrationFailedIssue"
  );

export const getOpenTofuMigrationWaitingForRunsIssue = (issues: OpenTofuMigrationIssueNode[]) =>
  issues.find(
    (issue): issue is OpenTofuMigrationWaitingForRunsIssueNode =>
      issue.__typename === "OpenTofuMigrationWaitingForRunsIssue"
  );
